import { useLocation, useSearchParams } from 'react-router-dom';
import { SearchEntity } from './SearchEntity';
import { DebouncedSearchClientInput } from '../../../../../../components/SearchClientInput';

export default function SearchBox() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSearchChange = (value: string) => {
    setSearchParams(value ? { search: value } : {});
  };

  if (location.pathname === '/clients') {
    return (
      <DebouncedSearchClientInput
        onSearchChange={handleSearchChange}
        initialValue={searchParams.get('search') ?? ''}
      />
    );
  } else {
    return <SearchEntity />;
  }
}
